export const EMPTY_CHILD_NAME = 'None';
export const EMPTY_CHILD_PATH = 'None';
